import apiClient from "@/services/axios";

export async function post(venueId, openingHours) {
  var response = await apiClient.post("/venue/info/openinghours", openingHours, {
    headers: {
      venueId: venueId
    }
  });
  if (response) {
    return response.data;
  }

  throw new Error("Unable to update opening hours.");
}
